import { Component, OnInit, HostListener, inject } from '@angular/core';
import { DOCUMENT, NgClass } from '@angular/common';
import { RippleEffectDirective } from '../../../../../@core/directives/core-ripple-effect/core-ripple-effect';
import { DefaultClassDirective } from '@ngbracket/ngx-layout/extended';
import { FeatherIconDirective } from '../../../../../@core/directives/core-feather-icons/core-feather-icons';

@Component({
    selector: 'app-scroll-top',
    templateUrl: './scroll-top.html',
    styleUrl: './scroll-top.scss',
    imports: [RippleEffectDirective, NgClass, DefaultClassDirective, FeatherIconDirective]
})
export class ScrollTopComponent implements OnInit {
  private document = inject<Document>(DOCUMENT);

  windowScrolled: boolean;
  topOffset: number = 150;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (
      window.pageYOffset > this.topOffset ||
      document.documentElement.scrollTop > this.topOffset ||
      document.body.scrollTop > this.topOffset
    ) {
      this.windowScrolled = true;
    } else if (
      (this.windowScrolled && window.pageYOffset) ||
      document.documentElement.scrollTop ||
      document.body.scrollTop < 10
    ) {
      this.windowScrolled = false;
    }
  }

  scrollToTop() {
    (function smoothscroll() {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;

      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothscroll);
        window.scrollTo(0, currentScroll - currentScroll / 8);
      }
    })();
  }

  ngOnInit() {}
}
